import "../components/plasmic/oblibena/plasmic.css"; // plasmic-import: dpdRoEHB1RdkpQGeaRP58K/projectcss
import "@/styles/globals.css";
import "survey-core/survey-core.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {AnalyticsProvider} from "@lg-plus/landing-components/analytics";
import {LGRuntimeProvider, useRuntimeConfig} from "@lg-plus/landing-components";
import {GoogleTag} from "@lg-plus/landing-components/GoogleTag";
import {SeznamCounter} from "@lg-plus/landing-components/SeznamCounter";
import {PlasmicRootProvider} from "@plasmicapp/react-web";
import type {AppProps} from "next/app";
import Head from "next/head";
import Link from "next/link";
import GlobalContextsProvider from "@/components/plasmic/oblibena/PlasmicGlobalContextsProvider";

export default function MyApp({Component, pageProps}: AppProps) {
    const config = useRuntimeConfig(pageProps);

    return (
        <PlasmicRootProvider Head={Head} Link={Link}>
            <Head>
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
                <link rel="manifest" href="/site.webmanifest" />
            </Head>
            <GlobalContextsProvider>
                <AnalyticsProvider config={config}>
                    <GoogleTag gtmId={config.gtmId} gtmCustomParams={config.gtmCustomParams} />
                    <SeznamCounter rtgId={config.seznamRtgId} />
                    <LGRuntimeProvider
                        config={config}
                        initialCommand={pageProps.initialCommand}
                        initialFormData={pageProps.initialFormData}
                        flashMessage={pageProps.flashMessage}
                    >
                        <Component {...pageProps} />
                    </LGRuntimeProvider>
                </AnalyticsProvider>
            </GlobalContextsProvider>
        </PlasmicRootProvider>
    );
}
